import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface RulerProps {
    className?: string
}

// Graduation de pied à coulisse : le motif récurrent du site.
export const Ruler: FC<RulerProps> = ({ className }): ReactNode => {
    const id = useId().replace(/[^a-zA-Z0-9_-]/g, '')

    return (
        <svg aria-hidden='true' focusable='false' className={cn('block h-3 w-full', className)}>
            <defs>
                <pattern id={`${id}-minor`} width='8' height='12' patternUnits='userSpaceOnUse'>
                    <rect width='1' height='5' fill='currentColor' />
                </pattern>
                <pattern id={`${id}-major`} width='80' height='12' patternUnits='userSpaceOnUse'>
                    <rect width='1' height='12' fill='currentColor' />
                </pattern>
            </defs>

            <rect width='100%' height='12' fill={`url(#${id}-minor)`} />
            <rect width='100%' height='12' fill={`url(#${id}-major)`} />
        </svg>
    )
}
